<template>

  <div>
          <v-toolbar
            dense
            tabs
            color="primary darken-2"
            dark
            class="page_title"
        >
            <v-toolbar-title class="pa-0 pr-0 mt-1">
                <v-layout row >
                    <v-flex xs10 sm11 text-xs-left>
                        <a href="javascript: history.go(-1)" class="pa-0">
                            <v-btn flat fab small class="pa-0">
                                <i class="fas fa-arrow-left headline"></i>
                            </v-btn>
                        </a>
                        Account details
                    </v-flex>
                    <v-flex xs2 sm1 text-xs-right>
                        <router-link :to="$store.state.close_url2" class="pa-0 text-xs-right">
                            <v-btn flat fab small class="pa-0">
                                <i class="fas fa-close headline"></i>
                            </v-btn>
                        </router-link>
                    </v-flex>
                </v-layout>
            </v-toolbar-title>
        </v-toolbar>
  <div class="dashboard-container">
    <!-- Filtres -->
    <div class="filters">
      <div class="filter-group">
        <label>Start Date</label>
        <input type="date" v-model="startDate" @change="handleFilterChange">
      </div>

      <div class="filter-group">
        <label>End Date</label>
        <input type="date" v-model="endDate" @change="handleFilterChange">
      </div>

      <div class="filter-group">
        <label>Statut</label>
        <select v-model="statusFilter" @change="handleFilterChange">
          <option value="all">All</option>
          <option value="paid">pay</option>
          <option value="pending">pending</option>
        </select>
      </div>

      <div class="filter-group">
        <label>Sort by</label>
        <select v-model="sortBy" @change="handleSortChange">
          <option value="date">Date</option>
          <option value="username">Name</option>
          <option value="commission">Commission</option>
        </select>
      </div>
    </div>

    <!-- Statistiques -->
    <div class="stats">
      <div class="stat-card">
        <div class="stat-header">
          <h3>Balance</h3>
          <span class="stat-icon">💰</span>
        </div>
        <div class="stat-amount">{{ formatCurrency(userBalance) }}</div>
      </div>

      <div class="stat-card">
        <div class="stat-header">
          <h3>Total Commissions</h3>
          <span class="stat-icon">📈</span>
        </div>
        <div class="stat-amount">{{ formatCurrency(totalCommissions) }}</div>
      </div>

      <div class="stat-card">
        <div class="stat-header">
          <h3>Pending</h3>
          <span class="stat-icon">⏳</span>
        </div>
        <div class="stat-amount-warning">{{ formatCurrency(pendingCommissions) }}</div>
      </div>
    </div>

    <!-- Tableau des affiliés -->
    <div class="affiliates-table">
      <table>
        <thead>
          <tr>
            <th @click="sortByField('date')">Date</th>
            <th @click="sortByField('username')">Name</th>
            <th @click="sortByField('status')">Statut</th>
            <th @click="sortByField('commission')">Commission</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in referredUsers" :key="user.id">
            <td>{{ formatBackendDate(user.created_at) }}</td>
            <td>{{ user.username }}</td>
            <td :class="statusClass(user.payment_status)">
              {{ user.payment_status ? 'Payé' : 'En attente' }}
            </td>
            <td>{{ formatCurrency(user.commission || 0) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CommissionDashboard',
  data() {
    return {
      startDate: null,
      endDate: null,
      statusFilter: 'all',
      sortBy: 'date',
      sortOrder: 'desc',
      userBalance: 0,
      totalCommissions: 0,
      pendingCommissions: 0,
      affiliateCount: 0,
      referredUsers: []
    }
  },

  mounted() {
    this.initializeDates();
    this.fetchDashboardData();
  },

  methods: {
    initializeDates() {
    const now = new Date()
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)

  },

    async fetchAllData() {
      await Promise.all([
        this.fetchDashboardData(),
        this.fetchTotalCommission()
      ]);
    },


    setupAutoRefresh() {
      this.refreshInterval = setInterval(() => {
        this.fetchTotalCommission();
      }, 30000); // Rafraîchit toutes les 30 secondes
    },

    async fetchDashboardData() {
  try {
    const params = {
      start_date: this.startDate,
      end_date: this.endDate,
      status: this.statusFilter,
      sort_by: this.sortBy,
      sort_order: this.sortOrder
    };

    const response = await axios.get('/api/v1/home/dashboard2/', { params });
    const data = response.data;

    this.userBalance = data.balance;
    this.totalCommissions = data.total_commissions;
    this.pendingCommissions = data.pending_commissions;
    this.affiliateCount = data.affiliate_count;
    
    this.referredUsers = data.referred_users.map(user => ({
      ...user,
      
      commission: user.commission || 0
    }));

  } catch (error) {
    console.error('Erreur:', this.getErrorMessage(error));
  }
    },
    formatBackendDate(dateString) {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Date invalide';
    
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Africa/Abidjan'
    });
  } catch (e) {
    console.error('Erreur de formatage:', dateString, e);
    return 'Date invalide';
  }
},
  safeDateParse(dateString) {
      try {
        const date = new Date(dateString)
        return isNaN(date) ? 'Date invalide' : this.formatBackendDate(date)
      } catch {
        return 'Date invalide'
      }
    },
    getErrorMessage(error) {
      return error.response?.data?.error || 'Erreur de communication avec le serveur';
    },

    handleFilterChange() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.fetchDashboardData(), 500);
    },

    handleSortChange() {
      this.fetchDashboardData();
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'XAF'
      }).format(value);
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('fr-FR');
    },

    statusClass(status) {
      return status ? 'status-paid' : 'status-pending';
    },

    sortByField(field) {
      this.sortBy = field;
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      this.fetchDashboardData();
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

input, select {
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.stat-card {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.stat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.stat-icon {
  font-size: 1.5rem;
}

.stat-amount {
  font-size: 2rem;
  font-weight: bold;
  color: #00479b;
}

.stat-amount.warning {
  color: #FF9800;
}

.stat-amount-warning {
  font-size: 2rem;
  font-weight: bold;
  color: #FF9800;
}

.affiliates-table {
  background: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

th {
  background-color: #f8f9fa;
  font-weight: 600;
}

th:hover {
  background-color: #e9ecef;
}

.status-paid {
  color: #4CAF50;
  font-weight: 500;
}

.status-pending {
  color: #FF9800;
  font-weight: 500;
}
.error-message {
  color: #dc3545;
  padding: 1rem;
  border: 1px solid #dc3545;
  border-radius: 4px;
  margin: 1rem 0;
}

.invalid-date {
  color: #dc3545;
  font-style: italic;
}
.date-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.calendar-icon {
  font-size: 0.9em;
}

.invalid-date {
  color: #ff4444;
  font-style: italic;
}

@media (max-width: 768px) {
  .filters {
    grid-template-columns: 1fr;
  }

  th, td {
    padding: 0.75rem;
    font-size: 0.9rem;
  }
}
</style>